var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _c("q-input", {
          staticClass: "no-shadow",
          attrs: {
            type: "number",
            name: "quickbooksId",
            "hide-underline": "",
            "inverted-light": "",
            color: _vm.inputBgColor
          },
          on: { input: _vm.updateParent },
          model: {
            value: _vm.qbSalesReceiptId,
            callback: function($$v) {
              _vm.qbSalesReceiptId = $$v
            },
            expression: "qbSalesReceiptId"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4" },
      [
        _c("q-btn", {
          staticClass: "full-width",
          attrs: {
            label: "View/Edit Receipt",
            icon: "receipt",
            color: "secondary",
            disable: !_vm.qbSalesReceiptId
          },
          on: {
            click: function($event) {
              return _vm.externalLink(
                "salesreceipt?txnId=" + _vm.qbSalesReceiptId
              )
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }